import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { MediaBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { backgroundColor } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/backgroundColor";
import { borderRadius } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/borderRadius";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { sizing } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/sizing";
import {
  ContentProp,
  CornersProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
  SizingProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Logo",
  version: 1,
  nameI18n: "builder_ui.block_type.logo",
  category: [MediaBlock],
  props: {
    image: {
      name: "Image",
      nameI18n: "builder_ui.prop_type.image.image",
      category: [ContentProp],
      prop: "other",
      type: "circle-image-upload",
      shouldAllowRemovingImage: true,
    },
    alt: {
      name: "Alt text",
      nameI18n: "builder_ui.prop_type.image.alt_text",
      category: [ContentProp],
      prop: "other",
      type: "string",
    },
    href: {
      name: "Link",
      nameI18n: "builder_ui.prop_type.link",
      category: [ContentProp],
      prop: "other",
      type: "url",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles.title",
      category: [DesignProp],
      prop: "styles",
      type: "styles",
      attributes: {
        backgroundColor: {
          ...backgroundColor,
          type: "color",
          nameI18n:
            "settings.emails.visual_builder.prop_type.styles.background_color",
          defaultValue: defaultStyles.backgroundColor,
          category: [DesignProp, GeneralProp],
        },
        sizing: {
          ...sizing,
          defaultValue: defaultStyles.sizing,
          category: [DesignProp, SizingProp],
        },
        borderRadius: {
          ...borderRadius,
          defaultValue: defaultStyles.borderRadius,
          category: [DesignProp, CornersProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
